import FeatureGate from "@/src/components/feature-gate";
import Events from "@/src/screens/events/events";

export default function EventsScreen() {
  return (
    <FeatureGate feature="events">
      <Events />
    </FeatureGate>
  );
}
